import React, { useRef, useState } from "react";
import NavBar from "./NavBar";
import CourseBookTable from "./CourseBookTable";
import CourseBookModal from "./CourseBookModal";
import {
  Box,
  Breadcrumbs,
  Button,
  Typography,
  Card,
  CardContent,
  Stack,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import { BUTTON_STYLES, CARD_STYLES } from "../styles/componentStyles";

const CourseBookMapping = () => {
  const [selectedMapping, setSelectedMapping] = useState(null);
  const [isNew, setIsNew] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(false); // used to force refresh
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const handleEdit = (mapping) => {
    setSelectedMapping(mapping);
    setIsNew(false);
    setShowModal(true);
  };

  const handleNew = () => {
    setSelectedMapping(null);
    setIsNew(true);
    setShowModal(true);
  };

  // Set by the modal after a successful edit that kept the mapping's key
  const pendingUpdateRef = useRef(null);
  const [updatedRow, setUpdatedRow] = useState(null);

  // A mapping is keyed by course, semester, book and regulation. The backend
  // re-inserts the row on update, and the list query has no ORDER BY, so a reload
  // would move the edited row to the end. When the key is unchanged, update the
  // row in place from the save response instead of reloading.
  const handleSaved = (saved, original) => {
    const sameKey =
      saved &&
      original &&
      ["courseId", "semesterId", "bookId", "regulationId"].every(
        (k) => String(saved[k]) === String(original[k])
      );
    pendingUpdateRef.current = sameKey ? { saved, original } : null;
  };

  const onCloseModal = () => {
    setShowModal(false);
    const update = pendingUpdateRef.current;
    pendingUpdateRef.current = null;
    if (update) {
      setUpdatedRow(update);
    } else {
      setRefreshTrigger(!refreshTrigger); // force refresh table data
    }
  };

  return (
    <div>
      {/* <NavBar /> */}

      {/* Header Section */}
      {/* <Card sx={CARD_STYLES.header}>
        <CardContent>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 1 }}>
              <Link underline="hover" color="inherit" to="/booklist">
                Books List
              </Link>
              <Typography sx={{ color: "text.primary", fontWeight: 600 }}>
                Course Book Mapping
              </Typography>
            </Breadcrumbs>
          </Box>

          <Stack direction="row" spacing={2} flexWrap="wrap" useFlexGap>
            <Button
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              onClick={handleNew}
              {...BUTTON_STYLES.primary}
            >
              Add New Mapping
            </Button>
          </Stack>
        </CardContent>
      </Card> */}

      {/* Content Section */}
      <Box sx={{}}>
        <CourseBookTable
          onEdit={handleEdit}
          refresh={refreshTrigger}
          updatedRow={updatedRow}
          handleNew={handleNew}
        />
        <CourseBookModal
          open={showModal}
          mapping={selectedMapping}
          isNew={isNew}
          onSaved={handleSaved}
          onClose={onCloseModal}
        />
      </Box>
    </div>
  );
};

export default CourseBookMapping;
